var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 28.3287V4.76681C1 4.43543 1.26863 4.16681 1.6 4.16681H9.66667V1.67157C9.66667 1.3402 9.9353 1.07157 10.2667 1.07157H17.7333C18.0647 1.07157 18.3333 1.3402 18.3333 1.67157V10.3573H26.4C26.7314 10.3573 27 10.6259 27 10.9573V28.3287C27 28.6601 26.7314 28.9287 26.4 28.9287H18.3333H1.6C1.26863 28.9287 1 28.6601 1 28.3287Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 28.9287H1.6C1.26863 28.9287 1 28.6601 1 28.3287V4.76681C1 4.43543 1.26863 4.16681 1.6 4.16681H9.66667V1.67157C9.66667 1.3402 9.9353 1.07157 10.2667 1.07157H17.7333C18.0647 1.07157 18.3333 1.3402 18.3333 1.67157V10.3573M18.3333 28.9287H26.4C26.7314 28.9287 27 28.6601 27 28.3287V10.9573C27 10.6259 26.7314 10.3573 26.4 10.3573H18.3333M18.3333 28.9287V22.7382M18.3333 10.3573V16.5478M18.3333 16.5478H21.2222M18.3333 16.5478V22.7382M18.3333 22.7382H21.2222",
    stroke: "#727272",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.77771 10.3727L6.79224 10.3554",
    stroke: "#16BFD8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5557 10.3728L12.5702 10.3555",
    stroke: "#16BFD8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.77771 16.5634L6.79224 16.5461",
    stroke: "#16BFD8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5557 16.5634L12.5702 16.5461",
    stroke: "#16BFD8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.77771 22.7536L6.79224 22.7363",
    stroke: "#16BFD8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5557 22.7539L12.5702 22.7366",
    stroke: "#16BFD8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon6.c9e71166d2d587a318e59b7cb9b1b089.svg";
export { ForwardRef as ReactComponent };